import { takeLatest } from 'redux-saga/effects';
import { GET_ESG_COVERAGE_DATA } from './esgCoverageActions';
import { fetchEsgCoverageDataSaga } from './esgCoverageSaga';

export function* esgCoverageWatchers() {
  yield takeLatest(GET_ESG_COVERAGE_DATA, fetchEsgCoverageDataSaga);
}
